module.exports = __webpack_public_path__ + "static/img/bdm_rank2.1e8816f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/bdm_rank2.png
// module id = QFiT
// module chunks = 0